export default __webpack_public_path__ + "static/media/Round.050e2f1d.png";